import { map } from 'lodash'
import plur from 'plur'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type GendersMultiSelectInput_query$key } from '@/__generated__/GendersMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type GendersMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: GendersMultiSelectInput_query$key | null | undefined
}

export const GendersMultiSelectInput = forwardRef<MultiSelectInputRef, GendersMultiSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment GendersMultiSelectInput_query on Query {
          genders(orderBy: [SEQUENCE_ASC]) {
            nodes {
              isOther
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <MultiSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.genders?.nodes, (gender) => ({
              isOther: gender!.isOther,
              label: gender!.isOther ? gender!.name : plur(gender!.name),
              value: gender!.rowId
            })),
          [queryData?.genders?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

GendersMultiSelectInput.displayName = 'GendersMultiSelectInput'
